import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryStateContext } from '../../contexts';
import { useDuplicateRequirement } from '../../hooks/requirement';

export const ACTION_MENU_OPTIONS = {
  REQUIREMENT: 'requirement',
  FIRST_CONDITION: 'firstCondition',
};

export const DuplicateButton = () => {
  const { DuplicateRequirementButton } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const duplicateRequirement = useDuplicateRequirement();
  if (isReadOnly) return null;

  return <DuplicateRequirementButton isDisabled={isReadOnly} onClick={duplicateRequirement} />;
};
